/* global
  __JOB_API__, __CRED_API__, __QUERY_API__, __SYNC_API__, __UPX_API__, __USER_API__, __CONTENT_API__
*/

import { Map } from 'immutable';
import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

const initialState = {
  credService: __CRED_API__,
  jobService: __JOB_API__,
  queryService: __QUERY_API__,
  syncService: __SYNC_API__,
  upxService: __UPX_API__,
  userService: __USER_API__,
  contentService: __CONTENT_API__,
};

const getIfPresent = (obj, key) => (
  Object.keys(obj).indexOf(key) > -1 ? obj[key] : null
);

const stateWithOverrides = (currentState, overrides) => (
  currentState.set('credService', getIfPresent(overrides, 'cred_service_override') || __CRED_API__)
    .set('jobService', getIfPresent(overrides, 'job_service_override') || __JOB_API__)
    .set('queryService', getIfPresent(overrides, 'query_service_override') || __QUERY_API__)
    .set('syncService', getIfPresent(overrides, 'sync_service_override') || __SYNC_API__)
    .set('upxService', getIfPresent(overrides, 'upx_service_override') || __UPX_API__)
    .set('userService', getIfPresent(overrides, 'user_service_override') || __USER_API__)
    .set('contentService', getIfPresent(overrides, 'content_service_override') || __CONTENT_API__)
);

class ServiceApiUrlsStore extends ReduceStore {
  getInitialState() {
    return new Map(initialState);
  }

  // eslint-disable-next-line class-methods-use-this
  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_LOADED:
        return stateWithOverrides(state,
          action.organization.organization_detail.service_url_overrides);
      default:
        return state;
    }
  }

  getCredServiceUrl() {
    return this.getState().get('credService');
  }

  getJobServiceUrl() {
    return this.getState().get('jobService');
  }

  getQueryServiceUrl() {
    return this.getState().get('queryService');
  }

  getSyncServiceUrl() {
    return this.getState().get('syncService');
  }

  getUpxServiceUrl() {
    return this.getState().get('upxService');
  }

  getUserServiceUrl() {
    return this.getState().get('userService');
  }

  getContentServiceUrl() {
    return this.getState().get('contentService');
  }
}

const instance = new ServiceApiUrlsStore(AppDispatcher);
export default instance;
